import { useRef, useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import { useIntersectionObserver } from 'usehooks-ts';

import { asIntersectionObserverRef } from '../../../utils/hooks';
import FadeIn from '../../../uiParts/FadeIn/FadeIn';
import Section from '../../../uiParts/Sections/Section/Section';
import SectionHeader2 from '../../../uiParts/SectionHeader2/SectionHeader2';
import TimeLine from '../../../uiParts/TimeLine/TimeLine/TimeLine';
import { useExperienceQuery } from '../../../../hooks/contentful';

import styles from './Experience.module.css';

export default function Experience() {
  const ref = useRef<HTMLElement>(null);
  const entry = useIntersectionObserver(asIntersectionObserverRef(ref), {
    root: null,
    rootMargin: '20px',
    threshold: 0.5,
    freezeOnceVisible: true,
  });
  const isVisible = !!entry?.isIntersecting;
  const control = useAnimation();
  const { data } = useExperienceQuery();

  useEffect(() => {
    control.start('show');
  }, [isVisible, control]);

  return (
    <Section ref={ref} className={styles.section}>
      <FadeIn controls={control} yOffset={10} duration={0.6}>
        <SectionHeader2 text="Experience" mb={60} />
      </FadeIn>
      {data &&
        data.items.map(({ sys: { id }, fields }, i, { length }) => {
          const isLast = length - 1 === i;

          return (
            <TimeLine
              key={id}
              isLast={isLast}
              date_start={fields.date_start}
              date_end={fields.date_end}
              title={fields.title}
              description={fields.description}
              role={fields.role}
            />
          );
        })}
    </Section>
  );
}
